class AntennaUtils {

    // every radio with its sector, in column order - the flat order the backend persists
    loadSectorRadios(entry) {
        return (entry.sectors ?? [])
            .flatMap(sector => (sector.radios ?? []).map(radio => ({ sector, radio })))
            .sort((a, b) => this.compareColumns(a.radio, b.radio));
    }

    // column order of two radios, new ones without a column last
    compareColumns(a, b) {
        return (a.column ?? Infinity) - (b.column ?? Infinity);
    }

    // highest column of the given radios, -1 without any
    lastColumn(radios) {
        return Math.max(-1, ...radios.map(radio => radio.column ?? -1));
    }

    // columns are the flat radio order the backend persists, so new radios get the next free one
    nextColumn(entry) {
        return this.lastColumn((entry.sectors ?? []).flatMap(sector => sector.radios ?? [])) + 1;
    }

    // makes room for count radios directly behind afterColumn
    shiftColumns(entry, afterColumn, count) {
        this.loadSectorRadios(entry).forEach(({ radio }) => {
            if (radio.column > afterColumn) {
                radio.column += count;
            }
        });
    }

    // stable identity of a sector or radio: persisted ones by id, new ones by their client key
    itemKey(item) {
        return item.id ? `id-${item.id}` : `key-${item.key}`;
    }

    // sectors are the antennas; index is the stable key for the plot arrows
    loadAntennas(entry) {
        return (entry.sectors ?? []).map((sector, index) => ({ index, ...sector }));
    }
}
const antennaUtils = new AntennaUtils();
export default antennaUtils;